<template>
    <el-dialog
        title="订单信息"
        width="800px"
        v-model="data.dialogTableVisible"
        class="order-detail-dialog"
    >
        <div class="order-detail-content">
            <!-- 订单信息 -->
            <div class="section">
                <div class="section-title">订单信息</div>
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">订单号：</span>
                        <span class="value">{{ currentData.id }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">订单状态：</span>
                        <span class="value status-tag">{{ orderStatus[currentData.status] }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">下单时间：</span>
                        <span class="value">{{ currentData.createTime }}</span>
                    </div>
                </div>
            </div>

            <!-- 车主信息 -->
            <div class="section">
                <div class="section-title">车主信息</div>
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">车主姓名：</span>
                        <span class="value">{{ data.orderInfo.washerName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">手机号：</span>
                        <span class="value">{{ data.orderInfo.washerPhone || '-' }}</span>
                    </div>
                </div>
            </div>

            <!-- 消费明细 -->
            <div class="section">
                <div class="section-title">消费明细</div>
                <div class="table-container">
                    <table class="detail-table">
                        <thead>
                        <tr>
                            <th></th>
                            <th>等待</th>
                            <th>泡沫</th>
                            <th>冲水</th>
                            <th>清水</th>
                            <th>风干</th>
                            <th>吸尘</th>
                            <th>臭氧</th>
                            <th>镀膜</th>
                            <th>预留1</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="row-label">用时(秒)</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeWait || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeFoam || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeWash || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeWater || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeDry || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeVacuum || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeOzone || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeCoat || 0 }}</td>
                            <td>{{ data.orderInfo.orderDetail?.TimeRes1 || 0 }}</td>
                        </tr>
                        <tr>
                            <td class="row-label">金额(元)</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeWait || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeFoam || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeWash || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeWater || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeDry || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeVacuum || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeOzone || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeCoat || 0) }}</td>
                            <td>{{ formatNumber(data.orderInfo.orderDetail?.FeeRes1 || 0) }}</td>
                        </tr>
                        <tr class="total-row">
                            <td class="row-label">合计时长</td>
                            <td colspan="9">{{ data.orderInfo.orderDetail?.SumTime || 0 }} 秒</td>
                        </tr>
                        <tr class="total-row">
                            <td class="row-label">合计金额</td>
                            <td colspan="9">{{ formatNumber(data.orderInfo.orderDetail?.SumFee || 0) }} 元</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- 支付信息 -->
            <div class="section">
                <div class="section-title">支付信息</div>
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">支付金额：</span>
                        <span class="value pay-amount">{{ formatNumber(data.orderInfo.payAmount || 0) }} 元</span>
                    </div>
                    <div class="info-item">
                        <span class="label">支付时间：</span>
                        <span class="value">{{ data.orderInfo.payTime || '-' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { defineComponent, reactive, inject } from "vue";
import { apiOrderDetails } from "@/api/requestApis.js";

export default defineComponent({
    props: {
        currentData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    setup(props) {
        const orderStatus = inject("orderStatus");
        const data = reactive({
            dialogTableVisible: false,
            orderInfo: {},
            orderDetail: {}
        });

        // 格式化数字为两位小数
        const formatNumber = (num) => {
            return Number(num).toFixed(2);
        };

        const handleToggle = (val) => {
            data.dialogTableVisible = val;
            if (val) {
                setTimeout(async () => {
                    try {
                        const res = await apiOrderDetails({
                            id: props.currentData.id,
                        });
                        data.orderInfo = res;
                    } catch (error) {
                        console.error("获取订单详情失败：", error);
                    }
                }, 10);
            }
        };

        return {
            orderStatus,
            handleToggle,
            data,
            formatNumber
        };
    },
});
</script>

<style scoped>
.order-detail-dialog {
    --el-dialog-padding-primary: 20px;
}

.order-detail-content {
    padding: 10px 0;
}

.section {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;
}

.section:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
}

.section-title::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 18px;
    background-color: #409eff;
    margin-right: 8px;
    border-radius: 2px;
}

.info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
}

.info-item {
    display: flex;
    align-items: center;
    min-width: 200px;
    padding: 4px 0;
}

.label {
    color: #666;
    font-weight: 500;
    min-width: 80px;
    margin-right: 8px;
}

.value {
    color: #333;
    flex: 1;
}

.status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: #e8f4ff;
    color: #409eff;
    font-size: 12px;
}

.pay-amount {
    color: #e6a23c;
    font-weight: 600;
}

.table-container {
    overflow-x: auto;
    margin-top: 8px;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.detail-table th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #666;
    padding: 12px 8px;
    border: 1px solid #ebeef5;
    text-align: center;
}

.detail-table td {
    padding: 12px 8px;
    border: 1px solid #ebeef5;
    text-align: center;
}

.row-label {
    background-color: #f9fafc;
    font-weight: 500;
    color: #666;
    text-align: left;
    padding-left: 16px;
}

.total-row {
    background-color: #f0f9ff;
}

.total-row td {
    font-weight: 600;
    color: #333;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .info-row {
        flex-direction: column;
        gap: 8px;
    }

    .info-item {
        min-width: auto;
        width: 100%;
    }

    .detail-table {
        font-size: 12px;
    }

    .detail-table th,
    .detail-table td {
        padding: 8px 4px;
    }
}
</style>
